import api from './api';

export type WalletTransactionRow = {
  _id: string;
  type: string;
  amount: number;
  description?: string;
  createdAt: string;
  balanceAfter?: number;
};

export type MyWalletSnapshot = {
  balance: number;
  currency: string;
  isFrozen: boolean;
  transactions: WalletTransactionRow[];
};

function readWalletBalance(payload: unknown): number {
  if (!payload || typeof payload !== 'object') return 0;
  const o = payload as { balance?: unknown; wallet?: { balance?: unknown } };
  if (typeof o.balance === 'number' && Number.isFinite(o.balance)) return o.balance;
  if (o.wallet && typeof o.wallet.balance === 'number' && Number.isFinite(o.wallet.balance)) {
    return o.wallet.balance;
  }
  return 0;
}

function readWalletMeta(payload: unknown): { currency: string; isFrozen: boolean } {
  if (!payload || typeof payload !== 'object') {
    return { currency: 'INR', isFrozen: false };
  }
  const o = payload as {
    currency?: string;
    isFrozen?: boolean;
    wallet?: { currency?: string; isFrozen?: boolean };
  };
  const src = o.wallet ?? o;
  return {
    currency: String(src.currency || 'INR'),
    isFrozen: Boolean(src.isFrozen),
  };
}

/** Partner/customer wallet from GET /wallet (+ recent transactions). */
export async function fetchMyWallet(limit = 50): Promise<MyWalletSnapshot> {
  const [walletRes, txRes] = await Promise.all([
    api.get('/wallet'),
    api.get('/wallet/transactions', { params: { page: 1, limit } }),
  ]);

  const walletPayload = walletRes.data?.data;
  const txPayload = txRes.data?.data;
  const meta = readWalletMeta(walletPayload);

  return {
    balance: readWalletBalance(walletPayload),
    currency: meta.currency,
    isFrozen: meta.isFrozen,
    transactions: (txPayload?.transactions ?? []) as WalletTransactionRow[],
  };
}
